<template>
    <b-card>
        <b-row class="mb-2">
            <b-col lg="12"><h4><strong>Filters</strong></h4></b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="6" md="4">
                <div class="mb-2">Date Range</div>
                <div class="d-flex align-items-center justify-content-between">
                    <date-picker
                        v-model="start_at"
                        placeholder="Start Date"
                        class="f-1">
                    </date-picker>&nbsp;to&nbsp;
                    <date-picker
                        v-model="end_at"
                        placeholder="End Date"
                        class="f-1">
                    </date-picker>
                </div>
            </b-col>
            <b-col sm="6" md="4">
                <b-form-group label="Parent Carrier" label-for="parent_carrier_id">
                    <carrier-parents-dropdown v-model="parent_carrier" />
                </b-form-group>
            </b-col>
            <b-col sm="6" md="4">
                <b-form-group label="Carrier" label-for="ltc_carrier_id">
                    <carrier-dropdown v-model="carrier" />
                </b-form-group>
            </b-col>
            <b-col sm="6" md="4">
                <b-form-group label="Sister Policy" label-for="sister_policy">
                    <b-form-select id="sister_policy" v-model="sister_policy">
                        <option value="">--</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button @click="loadItems()" variant="info" :disabled="loading || busy">Generate</b-button>
            </b-col>
        </b-row>
        <hr />
        <div>
            <b-row class="mb-2">
                <b-col lg="6">
                    <b-btn variant="success" :href="url + '&export=1'" :disabled="loading || busy">
                        <i class="fa fa-file-excel-o"></i> Export to Excel
                    </b-btn>
                </b-col>
                <b-col lg="6" class="text-right">
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                </b-col>
            </b-row>
            <div v-if="loading" class="text-center mt-3">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                <p>Loading Results...</p>
            </div>
            <b-table v-else bordered striped hover show-empty responsive
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
            >
                <template v-slot:cell(claimant_name)="row">
                    <a :href="`/business/clients/${row.item.claimant_id}`">{{ row.value }}</a>
                </template>
            </b-table>
            <b-row>
                <b-col lg="6" >
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </b-col>
                <b-col lg="6" class="text-right">
                    Showing {{ perPage < totalRows ? perPage : totalRows }} of {{ totalRows }} results
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            'defaults': [Object, Array],
        },

        data() {

            return {

                loading           : false,
                totalRows         : 0,
                perPage           : 25,
                currentPage       : 1,
                sortBy            : null,
                sortDesc          : false,
                filter            : null,
                start_at        : this.getDefault('start_at'),
                end_at          : this.getDefault('end_at'),
                parent_carrier    : this.getDefault('parent_carrier'),
                carrier           : this.getDefault('carrier'),
                sister_policy     : this.getDefault('sister_policy'),
                fields: [
                    {
                        key: 'claimant_name',
                        label: 'Claimant Name',
                        sortable: true
                    },
                    {
                        key: 'policy_number',
                        label: 'Policy Number',
                        sortable: true
                    },
                    {
                        key: 'intake_id_or_claim_number',
                        label: 'Intake ID/Claim Number',
                        sortable: true
                    },
                    {
                        key: 'claimant_active',
                        label: 'Claimant Active',
                        sortable: true
                    },
                    {
                        key: 'decommissioned_at',
                        label: 'Decommissioned At',
                        sortable: true
                    },
                    {
                        key: 'decommission_reason',
                        label: 'Decommission Reason',
                        sortable: true
                    }
                ],
                items: [],
                busy: false,
            }
        },

        computed: {
            url() {
                let query = {
                    json: '1',
                    start_at: this.start_at,
                    end_at: this.end_at,
                    parent_carrier: this.parent_carrier,
                    carrier: this.carrier,
                    sister_policy: this.sister_policy
                };
                if (query.start_at !== '') {
                    query.start_at = moment(query.start_at, 'MM/DD/YYYY').hour(0).minute(0).second(0).toISOString();
                }
                if (query.end_at !== '') {
                    query.end_at = moment(query.end_at, 'MM/DD/YYYY').hour(23).minute(59).second(59).toISOString();
                }
                query = Object.entries(query).filter(([, value]) => value !== null && value !== '');
                const params = new URLSearchParams(query);
                return `/business/reports/invoiced-user-list?${params.toString()}`;
            }
        },

        methods: {
            async loadItems() {
                this.loading = true;
                this.items = [];
                try {
                    const {data} = await axios.get(this.url);
                    this.items = data;
                    this.totalRows = data.length;
                } finally {
                    this.loading = false;
                }
            },

            getDefault(field, defaultValue = '') {
                if (this.defaults && this.defaults[field]) {
                    return this.defaults[field];
                }
                return defaultValue;
            },

            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            }
        }
    }
</script>
